import { mui } from '@local/finsera-core/src/libs';

const ColumnsPicker = () => {
  return (
    <mui.dataGrid.ColumnsPanelTrigger
      render={
        <mui.dataGrid.ToolbarButton
          render={
            <mui.core.Button type="button" size="small" sx={{ border: '0px!important' }}>
              Columns
            </mui.core.Button>
          }
        />
      }
    />
  );
};

export default ColumnsPicker;
